import { IntroSlide } from '../models';

export const INTRO_DESIGN_FRAME_WIDTH: number = 364;

export const INTRO_SLIDES: IntroSlide[] = [
  {
    id: 'find-game',
    image: 'assets/intro/find-game.png',
    imageWidth: 206,
    title: 'Znajdź gierkę w kilka sekund',
    description: 'Sprawdź na mapie kto gra w Twojej okolicy i dołącz jednym kliknięciem.',
    ctaLabel: 'Przejdź dalej',
    ctaVariant: 'light'
  },
  {
    id: 'host-game',
    image: 'assets/intro/host-game.png',
    imageWidth: 149,
    title: 'Organizuj gierki bez chaosu',
    description: 'W jednym miejscu znajdziesz wszystkich zawodników i powiadomisz ich o szczegółach gry.',
    ctaLabel: 'Przejdź dalej',
    ctaVariant: 'light'
  },
  {
    id: 'game-info',
    image: 'assets/intro/game-info.png',
    imageWidth: 180,
    title: 'Wszystkie informacje w jednym miejscu',
    description: 'Godzina, miejsce, liczba graczy i koszt boiska. Wszystkie najważniejsze informacje zawsze pod ręką.',
    ctaLabel: 'Przejdź dalej',
    ctaVariant: 'light'
  },
  {
    id: 'game-alerts',
    image: 'assets/intro/game-alerts.png',
    imageWidth: 249,
    title: 'Pozwól, żeby gierka znalazła Ciebie',
    description:
      'Ustaw swoje preferencje, a powiadomimy Cię, gdy w pobliżu pojawi się mecz, który będzie skrojony dla Ciebie.',
    ctaLabel: 'Przejdź dalej',
    ctaVariant: 'light'
  },
  {
    id: 'teams',
    image: 'assets/intro/teams.png',
    imageWidth: 206,
    title: 'Graj ze swoją grupką',
    description: 'Stwórz własną grupkę, zapraszaj znajomych i organizuj regularne gierki jeszcze szybciej.',
    ctaLabel: 'Przejdź do Orlikfy',
    ctaVariant: 'gradient'
  }
];
